import { CartIcon } from "./EcommerceIcons";

export default function EcommerceCartDrawer({ isOpen, onClose, cartItems, onUpdateQuantity, onCheckout }) {
  if (!isOpen) return null;

  const totalPrice = cartItems.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  const totalCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div className="ecomm-cart-drawer-overlay" onClick={onClose}>
      <div className="ecomm-cart-drawer" onClick={(event) => event.stopPropagation()}>
        <div className="ecomm-cart-drawer-header">
          <h3>Your Cart ({totalCount})</h3>
          <button onClick={onClose} aria-label="Close cart">
            &times;
          </button>
        </div>

        <div className="ecomm-cart-drawer-body">
          {cartItems.length === 0 ? (
            <div className="ecomm-cart-empty">
              <CartIcon />
              <p>Your cart is empty</p>
            </div>
          ) : (
            cartItems.map((item) => (
              <div className="ecomm-cart-drawer-item" key={item.product.id}>
                <img src={item.product.image} alt={item.product.title} />
                <div>
                  <h4>{item.product.title}</h4>
                  <div className="ecomm-cart-row">
                    <span>₹{item.product.price}</span>
                    <div className="ecomm-qty small">
                      <button onClick={() => onUpdateQuantity(item.product.id, item.quantity - 1)}>-</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => onUpdateQuantity(item.product.id, item.quantity + 1)}>+</button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {cartItems.length > 0 && (
          <div className="ecomm-cart-drawer-footer">
            <div>
              <span>Total Amount:</span>
              <strong>₹{totalPrice}</strong>
            </div>
            <button onClick={onCheckout}>Checkout (₹{totalPrice})</button>
          </div>
        )}
      </div>
    </div>
  );
}
